import {http} from "@/assets/utils/api";

/**
 * 获取测评列表
 * @param {*} data 
 * @returns 
 */
export const getTestPaperList = (data) => http.post('/yymPaperAppraisal/getList',data,{custom: {isAuth: false}});

/**
 * 获取测评信息
 */
export const getTestPaperInfo = (paperAppraisalId) => http.get(`/yymPaperAppraisal/${paperAppraisalId}`,{custom: {isAuth: false}});

/**
 * 手机用户信息
 */
export const collectUserInfo = (data) => http.post('/yymPaperAppraisalUser/add',data,{custom: {isAuth: false}});

/**
 * 获取测评试卷
 */
export const getTestPaper = (paperId,buyerUserId) => http.get(`/yymPaperAppraisal/getByPaperId/${paperId}/${buyerUserId}`,{custom: {isAuth: false}});

/**
 * 测评卷提交
 */
export const submitTestPaper = (data) => http.post('/yymPaperAppraisal/savePaperRecord',data,{custom: {isAuth: false,isTimeout: true}});

/**
 * 测评卷作答记录
 */
export const getTestPaperRecord = (recordId) => http.get(`/yymPaperAppraisal/getRecordDetail/${recordId}`,{custom: {isAuth: false}});

/**
 * 测评统计
 */
export const testPaperCount = (recordId) => http.get(`/yymPaperAppraisal/getCount/${recordId}`,{custom: {isAuth: false}});

/**
 * 测评报告
 */
export const getTestPaperReport = (recordId) => http.get(`/yymPaperAppraisal/report/appraisal/${recordId}`,{custom: {isAuth: false,isTimeout: true}});

/**
 * 测评报告生成状态
 */
export const getTestPaperReportStatus = (recordId) => http.get(`/yymPaperAppraisal/report/status/${recordId}`,{custom: {isAuth: false}})